/**
 * Site header for account / admin pages.
 * Delegates to the canonical PublicSiteChrome so auth CTA and nav stay in sync site-wide.
 */
import PublicSiteChrome from './site/PublicSiteChrome';

interface HeaderProps {
  subtitle?: string;
  active?:
    | 'profile'
    | 'admin'
    | 'developers'
    | 'home'
    | 'plugins'
    | 'digipin'
    | 'cliptocad'
    | 'login'
    | 'issues';
}

const Header = ({ subtitle = 'Account', active }: HeaderProps) => {
  return <PublicSiteChrome subtitle={subtitle} active={active} />;
};

export default Header;
